import { config } from "@/config";
export const ValoresService = {
    async getValorById(id) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/${id}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el valor con id ${id}`);
        }
        const result = await response.json();
        return result.data;
    },
    async getAllValores() {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener todos los valores desplegables");
        }
        const result = await response.json();
        if (!result.data || !Array.isArray(result.data)) {
            console.error('Se esperaba un array de valores en la propiedad "data" pero se recibió:', result);
            return [];
        }
        return result.data;
    },
    async getValoresByNombreAtributoId(nombreAtributoId) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/nombreAtributo/${nombreAtributoId}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener los valores del NombreAtributoID ${nombreAtributoId}`);
        }
        const result = await response.json();
        return result.data;
    },
    async addValor(valor) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(valor),
        });
        if (!response.ok) {
            let errorMessage = "Error al agregar el valor desplegable";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) { }
            throw new Error(errorMessage);
        }
    },
    async updateValor(id, valor) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(valor),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar el valor desplegable");
        }
    },
    async updateOrdenValor(id, nuevoOrden) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/${id}/orden`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(nuevoOrden),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar el orden del valor desplegable");
        }
    },
    deleteValor: async (id) => {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            let errorMessage = "Error al eliminar el valor desplegable";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) { }
            throw new Error(errorMessage);
        }
    },
    async exportReport(request) {
        try {
            const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/export`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: JSON.stringify(request),
            });
            if (!response.ok)
                throw new Error("Error al exportar el reporte de valores desplegables");
            const format = request.format || "excel";
            const extension = format === "pdf" ? "pdf" : "xlsx";
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const timestamp = new Date()
                .toISOString()
                .replace(/[:.]/g, "-")
                .slice(0, 19);
            link.setAttribute("download", `ValoresDesplegables_${timestamp}.${extension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error("Error al exportar el reporte:", error);
            throw error;
        }
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/ValoresDesplegables/${id}/toggle-activo`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok) {
            throw new Error("No se pudo cambiar el estado del valor");
        }
    },
};
